import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        welcome: "Welcome to our website!",
        editTooltip: "Edit",
        saveTooltip: "Save",
        button: "Switch Language",
        tabs: {
          all: "All",
          important: "Important",
          favourite: "Favorite",
        },
        itemsPerPage: "Items per page:",
        chatButton: "AI Chat",
        searchButton: "Search",
        aiLabel: "AI",
        darkMode: {
          light: "Light Mode",
          dark: "Dark Mode",
        },
        logOut: "Log Out",
        switchLanguage: "Switch Language",
        pagination: {
          next: "Next",
          previous: "Previous",
        },
        searchPlaceholder: "Search documents...",
        searchPlaceholderTooltip:
          "This is a semantic search — it understands context, so results may match even if the wording isn’t precise.",
        selectPlaceholder: "Select...",
        noData: "No data found",
        exportReport: "Export",
        exportReportBlock: "Export (disabled). No regulators are selected",
        exportDocx: "Export to Docx (limit 300 records)",
        exportExcel: "Export to Excel (limit 800 records)",
        generateTaxAlertRo: "Generate Tax Alert (RO)",
        generateTaxAlertEng: "Generate Tax Alert (ENG)",
        errorExport: "Exporting Report has failed.",
        exportLoading: "Exporting…",
        exportSuccess: "Report is exported successfully",
        errorChatAIResponse: "AI Chat has failed. Try again",
        retryMessage: "Try again",
        switchThemes: "Switch themes",
        downloadUserGuise: "Download User Guide",
        actions: "Actions",
        aiDisclaimer:
          "Legal Insight Monitor can make mistakes or occasionally hallucinate. Please review the outputs critically prior to using them.",
        filtersSection: {
          filters: "Filters",
          clearFilters: "Clear filters",
          country: "Jurisdiction",
          regulatorName: "Source",
          dateOfPublication: "Date of Publication",
          dateOfHearing: "/Hearing",
          keywordsAndTags: "Keywords and tags",
          dateOfIssue: "Date of Issue",
          class: "Class",
          setYesterdaysDate: "Set Yesterday's Date",
          fromToPlaceholder: "From - To",
          searchAndSelectKeywords: "Search and select keywords...",
          searchAndSelectClass: "Search and select class...",
          searchAndSelectTags: "Search and select tags...",
          searchAndSelectTechProduct: "Search and select tech product...",
          searchAndSelectTechSection: "Search and select tech section...",
          searchAndSelectGazetteNumber: "Search and select gazette numbers...",
          searchAndSelectJudges: "Search and select judges...",
          searchAndSelectStatus: "Search and select status...",
          searchAndSelectCity: "Search and select city...",
          searchAndSelectSubjectMatter: "Search and select subject matter...",
          searchAndSelectTaxAlert: "Search and select tax alert...",
          from: "from:",
          until: "until:",
          techProduct: "Tech Product",
          techSectionVATAct: "Tech Section VAT Act",
          gazetteNumber: "Gazette Number",
          judges: "Judges",
          status: "Status",
          city: "City",
          subjectMatter: "Subject-Matter",
        },
        tooltips: {
          remove: "Remove",
          addTag: "Add tag",
          openOriginalDocument: "Open the document",
        },
        docInfo: {
          dateOfPublication: "Date of Publication:",
          dateOfHearing: "Date of Hearing:",
          regulators: "Source:",
          shortSummary: "Short AI Summary:",
          class: "Class:",
          confirmRemoveTag: "Are you sure you want to delete this tag?",
          city: "City:",
          judges: "Judges:",
          status: "Status:",
          techProduct: "Tech Product:",
          techSectionVATAct: "Tech Section VAT Act:",
          gazetteNumber: "Gazette Number:",
          taxAlert: "Tax Alert:",
        },
        chatAI: {
          askLegalQuestion: "Ask a question...",
          summaryDeleted: "The Summary is unattached from the context",
          howMayIHelp: "How may I help you?",
          requestsLeftWarning: "You have {{left}} chat requests left this month.",
          requestsLimitReached: "You have used all chat requests for this month.",
          summaryAdded: "The Summary is attached to the context",
          unAttach: "Unattach",
          savedPrompts: "Saved Prompts",
          outputAdjustments: "Output format",
          tone: "Tone",
          professional: "Professional",
          casual: "Casual",
          simple: "Simple",
          format: "Format",
          paragraph: "Paragraph",
          email: "E-mail",
          ideas: "Ideas",
          article: "Article",
          length: "Length",
          short: "Short",
          medium: "Medium",
          long: "Long",
          selectAll: "Chat with the most relevant documents",
          copyText: "Copy Text",
          exportChatConvTooltip: "Download Chat Conversation",
          clearChatConvTooltip: "Clear Chat Conversation",
          openOutputAdjTooltip: "Open Output Format",
          openPromptLibraryTooltip: "Open Prompt Library",
          closePromptLibraryTooltip: "Close Prompt Library",
          copied: "Copied",
          edit: "Edit",
          editResponse: "Edit response",
          saveEdit: "Save",
          cancelEdit: "Cancel",
        },
        pdfViewer: {
          failedToLoad: "Failed to load document",
          failedToInitialize: "Failed to initialize PDF viewer",
        },
        docDetails: {
          signature: "Signature",
          comments: "Comments",
          information: "Information",
          summary: "Summary",
          chatAI: "Chat",
          caseName: "Case name",
          dateOfPublication: "Date of publication",
          dateOfHearing: "Date of hearing",
          regulator: "Source",
          class: "Class",
          keywords: "Keywords",
          participants: "Participants",
          provisions: "Provisions",
          decision: "Decision",
          link: "Link",
          shortSummary: "Short AI Summary",
          copyToChatAI: "Copy to AI Chat",
          loadMore: "Load more",
          noResultsFound: "No results found",
          saveDocInfoToaster: "Document info were updated",
          teamSummary: "Team Summary",
          aiSummary: "AI Summary",
          copyToTeamSummary: "Copy To Team Summary",
          lotusNotesLink: "Lotus Notes File Links",
          fetchDocLinkToaster: "Lotus Notes File Link is fetched successfully",
          city: "City",
          officialGazetteNumber: "Official Gazette Number",
          title: "Title",
          promulgation: "Promulgation",
          subjectMatter: "Subject-Matter",
          text: "Text",
          techProduct: "Tech Product",
          techSectionVATAct: "Tech Section VAT Act",
          gazetteNumber: "Gazette Number",
          judges: "Judges",
          status: "Status",
          saveTeamSummary: "Team Summary is saved successfully",
          commentsPlaceholder:
            "Add a comment. Use @ to mention a member of your team.",
          addCommentToaster: "Team Comment is created successfully",
          unsavedTitle: "Unsaved changes",
          unsavedBody:
            "You have unsaved summary changes. Discard them to switch tabs.",
          unsavedKeep: "Keep editing",
          unsavedDiscard: "Discard changes",
          noComment: "No comments yet...",
          deleteComment: "Delete comment",
          noMatches: "No matches",
          editCommentToaster: "Comment is updated successfully",
          deleteCommentToaster: "Comment is deleted successfully",
          deleteCommentMsg: "Are you sure you want to delete this Comment?",
          taxAlert: "Tax Alert",
          dateOfIssue: "Date of issue",
          latestConsolidatedDate: "Latest consolidated publication date",
        },
        adminPanel: {
          superadminTitle: "Superadmin Panel",
          notifications: "Notifications",
          adminTitle: "Admin Panel",
          manageUsersTab: "Manage Users",
          uploadFilesTab: "Upload Files",
          userSettings: "User Settings",
          team: "Teams",
          addTeam: "Add Team",
          editTeam: "Edit Team",
          deleteTeam: "Delete Team",
          confirmMsgUser: "Are you sure you want to delete this user?",
          confirmMsgTeam: "Are you sure you want to delete this team?",
          cancel: "Cancel",
          delete: "Delete",
          searchInputPlaceholder: "Search: name, email, role, team",
          save: "Save",
          deleteUser: "Delete User",
          removeTeam: "Remove User from the Team",
          deleteUserTeam:
            "Are you sure you want to delete this User from the Team?",
          addUser: "Add User",
          add: "Add",
          submit: "Submit",
          loading: "Loading...",
          emailPlaceholder: "Provide e-mail",
          singleUserMode: "Add Single User",
          emailGroup: "Use Group Email",
          emailGroupPlaceholder: "Provide E-mail group",
          noEmailsFound: "No emails found for this group email.",
          invalidEmail: "Please enter a valid email address.",
          columns: {
            name: "Name",
            email: "E-mail",
            role: "Role",
            team: "Team",
            editRole: "Edit Role",
            editTeam: "Edit Team",
          },
          createNewTeam: "Create a New Team",
          adminUser: "Admin User",
          regulators: "Regulators",
          teamName: "Team Name",
          otherTeamMembers: "Members from other Team",
          selectAdminUser: "Select Admin User",
          selectRegulators: "Select Regulators",
          teamNamePlaceholder: "Provide Team Name",
          chatLimitPerUser: "Limit Of Chat Requests Per User",
          teamMembers: "Team Members",
          roleChangeToaster: "Role change is saved successfully",
          teamChangeToaster: "Team change is saved successfully",
          addTeamToaster: "Team is added successfully",
          editTeamToaster: "Team is edited successfully",
          deleteTeamToaster: "Team is deleted successfully",
          addUserToaster: "User is added successfully",
          addUserListToaster: "Group of users has been added successfully",
          promptLibrary: "Prompt Library",
          addSuperuser: "Add Superuser",
          sortAz: "Sort A-Z",
          sortZa: "Sort Z-A",
          addRegulator: "Request Regulator",
          addRegulatorTitle: "Request New Regulator",
          description: "Description",
          descriptionPlaceholder: "Provide description",
          files: "Files",
          file: "File",
          addRegulatorToaster:
            "Request form for adding new regulator is sent",
          fileDropFileTitle: "Click or drag files to this area to upload",
          acceptedFiles: "Accepted files:",
        },
        userSettings: {
          preferredFilters: "Preferred Filters",
          filtersInfoText:
            "Select your preferred filters for a personalized experience",
          selectCountry: "Select Country",
          selectRegulator: "Select Regulator",
          selectClass: "Select Class",
          noClass:
            "No Classes was found. Please select a Country or Regulator.",
          discardChangesBtn: "Discard Changes",
          saveChangesToaster: "Your changes were saved",
          discardChangesToaster: "Your changes were discarded",
        },
        promptLibrary: {
          promptsTitle: "Prompts",
          prompts: "My Prompts",
          teamPrompts: "Team's Prompts",
          allPrompts: "All Prompts",
          title: "Title",
          text: "Text",
          team: "Team",
          addPrompts: "Add Prompt",
          searchPrompt: "Search: name, email, role, team",
          editPrompt: "Edit Prompt",
          deletePrompt: "Delete Prompt",
          promptChangeToaster: "Prompt is updated successfully",
          savePrompt: "Save Prompt",
          deletePromptMsg: "Are you sure you want to delete this Prompt?",
          deletePromptToaster: "Prompt is deleted successfully",
          addPromptToaster: "Prompt is added successfully",
          textPlaceholder: "Provide Text",
          titlePlaceholder: "Provide Title",
          promptLibraryLink: "Manage prompts",
        },
        translateModal: {
          translatePageFrom: "Translate Decision, Short Summary, AI Summary",
          translateTo: "Translate to",
          showOriginal: "Show Original",
          translate: "Translate",
          translationTooltip: "Translation is done successfully",
          selectedLang: "Text is already in selected language.",
        },
        newRecordModal: {
          saveNewRecordToaster: "New record is added successfully",
          addNewRecordTitle: "Add New Record",
          saveDraft: "Saving draft...",
          caseNamePlaceholder: "Enter unique case name",
          date: "Date",
          tags: "Tags",
          singleFileAllow: "Only one file allowed",
          multipleFileAllow: "Multiple files allowed",
          fileRequiredError: "At least one file is required",
          linkPlaceholder: "URL must start with http/https",
          back: "Back",
          generateAIField: "Generate field using AI",
          shortSummary: "Short Summary",
          provisionPlaceholder: "Provide provisions",
          step1: "Step 1 of 3",
          step2: "Step 2 of 3",
          step3: "Step 3 of 3",
          shortSummaryTextTooltip:
            "Text field can't be empty for generation Short Summary field using AI",
          shortSummaryTooltip:
            "Summary field can't be empty for generation Short Summary field using AI",
        },
        feedback: {
          shortSummary: "Short AI Summary",
          class: "Classification issue",
          chat: "AI Chat issue",
          wrongInfo: "Wrong information",
          other: "Other",
          addFeedbackToaster: "Feedback is sent successfully",
          feedbackTitle: "Leave Feedback",
          section: "Section",
          comment: "Comment",
          files: "Files",
          cancel: "Cancel",
          send: "Send",
        },
        example: {
          title: "Example",
          example1Title: "Website link:",
          example2Title: "Search/filtering details:",
          example3Title: "Classification preferences:",
          example4Title: "AI-generated summary content:",
          example5Title: "Contact details:",
          example6Title: "Screenshots attached:",
          example2Text:
            "In the search form in “Soud” you need to select Supreme Administrative Court “Nejvyšší správní soud”. In “Druh dokumentu” you need to select Rodzsudek as a document type. The decisions are issued and published on the website on the same date.  ",
          example3Text1: "Classify the monitored information by:",
          example3Text2:
            "1. Document type: Decision, Opinion, Resolution, Other",
          example3Text3:
            "2. Custom classification: Value added tax, Customs, Personal Income Tax.",
          example4Text:
            "The summary should include subject-matter, parties' arguments, and court’s final decision.",
          example5Team: "Team: Tax Team",
          example5Email: "Emails: example@deloittece.com",
          example5Text1: "Main updates page",
          example5Text2: "Search form with selected filters",
          example5Text3: "Example of a filtered results page",
        },
        instruction: {
          title: "Instructions",
          userTitle: "Dear User,",
          text0:
            "If you wish to add a regulator for monitoring in Legal Insight Monitor, please provide the following details. Our specialist will contact you for further clarification.",
          text1: "Please provide the URL of the regulator’s official website.",
          text2:
            "If the website offers a search form or filters, please describe how you typically narrow down the information you’re interested in (e.g., by type of document, by keywords, etc.)",
          text3: "How would you like to classify the monitored information?",
          text4:
            "What key points or data should be included in AI-generated summary for each document or update?",
          text5:
            "Please provide your team name and email addresses so we can reach out if we need additional information.",
          text6:
            "To help us better understand the structure of the regulator’s website, please attach screenshots of the relevant pages or  search forms to your request.",
          bestRegards: "Best regards,",
          codetTeam: "Legal Insight Monitor Team",
        },
        notification: {
          createNotification: "Create Notification",
          active: "Active",
          inactive: "Inactive",
          subject: "Subject",
          team: "Team",
          regulators: "Regulators",
          classes: "Classes",
          schedule: "Schedule",
          status: "Status",
          all: "All",
          days: "Days of the week",
          time: "Time",
          timezone: "Timezone",
          editNotification: "Edit Notification",
          deleteNotification: "Delete Notification",
          deleteNotificationMsg:
            "Are you sure you want to delete this Notification?",
          searchNotification: "Search: name, email, role, team",
          frequency: "Notification Frequency",
          recipients: "Recipients",
          create: "Create",
          step1: "Step 1 of 2",
          step2: "Step 2 of 2",
          notificationChangeToaster:
            "Notification is updated successfully",
          deleteNotificationToaster:
            "Notification is deleted successfully",
          addNotificationToaster: "Notification is added successfully",
          searchAndSelectRecipients: "Search and select recipients...",
          searchAndSelectRegulator: "Search and select regulator...",
          subjectPlaceholder: "Provide Subject",
          allClasses: "All classes",
          selectAtLeastOneDay: "Select at least one Day",
          on: "On",
          off: "Off",
        },
      },
    },
    pl: {
      translation: {
        welcome: "Witamy na naszej stronie!",
        editTooltip: "Edytuj",
        saveTooltip: "Zapisz",
        button: "Zmień język",
        tabs: {
          all: "Wszystkie",
          important: "Ważne",
          favourite: "Ulubione",
        },
        itemsPerPage: "Ilość na stronę:",
        chatButton: "Czat AI",
        searchButton: "Szukaj",
        aiLabel: "AI",
        darkMode: {
          light: "Tryb Jasny",
          dark: "Tryb Ciemny",
        },
        logOut: "Wyloguj się",
        switchLanguage: "Zmień język",
        pagination: {
          next: "Następna",
          previous: "Poprzednia",
        },
        searchPlaceholder: "Szukaj dokumentów...",
        searchPlaceholderTooltip:
          "To jest wyszukiwanie semantyczne — rozumie kontekst, więc wyniki mogą pasować, nawet jeśli sformułowanie nie jest dokładne.",
        selectPlaceholder: "Wybierz...",
        noData: "Brak danych",
        exportReport: "Eksportuj",
        exportReportBlock:
          "Eksport (wyłączony). Nie wybrano żadnych regulatorów",
        exportDocx: "Eksportuj do Docx (limit 300 rekordów)",
        exportExcel: "Eksportuj do Excel (limit 800 rekordów)",
        generateTaxAlertRo: "Wygeneruj Tax Alert (RO)",
        generateTaxAlertEng: "Wygeneruj Tax Alert (ENG)",
        errorExport: "Eksportowanie raportu nie powiodło się.",
        exportLoading: "Eksportowanie…",
        exportSuccess: "Raport został pomyślnie wyeksportowany",
        errorChatAIResponse: "AI Chat nie powiódł się. Spróbuj ponownie",
        retryMessage: "Spróbuj ponownie",
        switchThemes: "Zmień motywy",
        downloadUserGuise: "Pobierz „Legal Insight Monitor User Guide”",
        actions: "Działania",
        aiDisclaimer:
          "Legal Insight Monitor może popełniać błędy lub okazjonalnie halucynować. Prosimy o krytyczne przejrzenie wyników przed ich użyciem.",
        filtersSection: {
          filters: "Filtry",
          clearFilters: "Wyczyść filtry",
          country: "Kraj",
          regulatorName: "Źródła",
          dateOfPublication: "Data publikacji",
          dateOfHearing: "/Rozprawy",
          keywordsAndTags: "Słowa kluczowe i tagi",
          dateOfIssue: "Data wydania",
          class: "Klasa",
          setYesterdaysDate: "Ustaw Datę Wczorajszą",
          fromToPlaceholder: "Od - Do",
          searchAndSelectKeywords: "Szukaj i wybierz słowa kluczowe...",
          searchAndSelectClass: "Wyszukaj i wybierz klasę...",
          searchAndSelectTags: "Szukaj i wybierz tagi...",
          searchAndSelectTechProduct:
            "Wyszukaj i wybierz produkt techniczny...",
          searchAndSelectTechSection: "Wyszukaj i wybierz sekcję techniczną...",
          searchAndSelectGazetteNumber: "Wyszukaj i wybierz numer dziennika...",
          searchAndSelectJudges: "Wyszukaj i wybierz sędziów...",
          searchAndSelectStatus: "Wyszukaj i wybierz status...",
          searchAndSelectCity: "Wyszukaj i wybierz miasto...",
          searchAndSelectSubjectMatter:
            "Wyszukaj i wybierz przedmiot sprawy...",
          searchAndSelectTaxAlert: "Wyszukaj i wybierz tax alert...",
          from: "od:",
          until: "do:",
          techProduct: "Produkt Techniczny",
          techSectionVATAct: "Sekcja Techniczna Ustawy o VAT",
          gazetteNumber: "Numer Dziennika",
          judges: "Sędziowie",
          status: "Status",
          city: "Miasto",
          subjectMatter: "Przedmiot Sprawy",
        },
        tooltips: {
          remove: "Usuń",
          addTag: "Dodaj tag",
          openOriginalDocument: "Otwórz dokument",
        },
        docInfo: {
          dateOfPublication: "Data publikacji:",
          dateOfHearing: "Data Rozprawy:",
          regulators: "Źródło:",
          shortSummary: "Krótkie Podsumowanie AI:",
          class: "Klasa:",
          confirmRemoveTag: "Czy na pewno chcesz usunąć ten tag?",
          city: "Miasto:",
          judges: "Sędziowie:",
          status: "Status:",
          techProduct: "Produkt Techniczny:",
          techSectionVATAct: "Sekcja Techniczna Ustawy o VAT:",
          gazetteNumber: "Numer Dziennika:",
          taxAlert: "Tax Alert:",
        },
        chatAI: {
          askLegalQuestion: "Zadaj pytanie prawne...",
          summaryDeleted: "Podsumowanie jest oderwane od kontekstu",
          howMayIHelp: "Jak mogę ci pomóc?",
          requestsLeftWarning: "Pozostało Ci {{left}} zapytań do czatu w tym miesiącu.",
          requestsLimitReached: "Wykorzystano wszystkie zapytania do czatu w tym miesiącu.",
          summaryAdded: "Podsumowanie jest dołączone do kontekstu",
          unAttach: "Odłącz",
          savedPrompts: "Zapisane Promptów",
          outputAdjustments: "Format wyjścia",
          tone: "Ton",
          professional: "Profesjonalny",
          casual: "Swobodny",
          simple: "Prosty",
          format: "Format",
          paragraph: "Akapit",
          email: "E-mail",
          ideas: "Pomysły",
          article: "Artykuł",
          length: "Długość",
          short: "Krótki",
          medium: "Średni",
          long: "Długi",
          selectAll: "Czat z najbardziej odpowiednimi dokumentami",
          copyText: "Kopiuj tekst",
          exportChatConvTooltip: "Pobierz rozmowę czatu",
          clearChatConvTooltip: "Wyczyść rozmowę czatu",
          openOutputAdjTooltip: "Otwórz ustawienia wyników",
          openPromptLibraryTooltip: "Otwórz bibliotekę promptów",
          closePromptLibraryTooltip: "Zamknij bibliotekę promptów",
          copied: "Skopiowano",
          edit: "Edit",
          editResponse: "Edit response",
          saveEdit: "Save",
          cancelEdit: "Cancel",
        },
        pdfViewer: {
          failedToLoad: "Nie udało się załadować dokumentu",
          failedToInitialize: "Nie udało się zainicjować przeglądarki PDF",
        },
        docDetails: {
          signature: "Podpis",
          comments: "Komentarze",
          information: "Informacje",
          summary: "Streszczenie",
          chatAI: "Czat",
          caseName: "Nazwa sprawy",
          dateOfPublication: "Data publikacji",
          dateOfHearing: "Data rozprawy",
          regulator: "Źródło",
          class: "Klasa",
          keywords: "Słowa kluczowe",
          participants: "Uczestnicy",
          provisions: "Przepisy",
          decision: "Decyzja",
          link: "Link",
          shortSummary: "Krótkie Podsumowanie AI",
          copyToChatAI: "Skopiuj do AI Chat",
          loadMore: "Załaduj więcej",
          noResultsFound: "Nie znaleziono wyników",
          saveDocInfoToaster: "Informacje o dokumencie zostały zaktualizowane",
          teamSummary: "Podsumowanie Zespołu",
          aiSummary: "Podsumowanie AI",
          copyToTeamSummary: "Kopiuj Do Podsumowania Zespołu",
          lotusNotesLink: "Linki Do Plików Lotus Notes",
          fetchDocLinkToaster:
            "Link do pliku Lotus Notes został pobrany pomyślnie",
          city: "Miasto",
          officialGazetteNumber: "Numer Dziennika Urzędowego",
          title: "Tytuł",
          promulgation: "Promulgacja",
          subjectMatter: "Przedmiot Sprawy",
          text: "Tekst",
          techProduct: "Produkt Techniczny",
          techSectionVATAct: "Sekcja Techniczna Ustawy o VAT",
          gazetteNumber: "Numer Dziennika",
          judges: "Sędziowie",
          status: "Status",
          saveTeamSummary: "Podsumowanie zespołu zostało zapisane",
          commentsPlaceholder:
            "Dodaj komentarz. Użyj @, aby wspomnieć członka zespołu.",
          addCommentToaster: "Komentarz zespołu został utworzony",
          unsavedTitle: "Unsaved changes",
          unsavedBody:
            "You have unsaved summary changes. Discard them to switch tabs.",
          unsavedKeep: "Keep editing",
          unsavedDiscard: "Discard changes",
          noComment: "Brak komentarzy...",
          deleteComment: "Usuń komentarz",
          noMatches: "Brak wyników",
          editCommentToaster: "Komentarz został zaktualizowany",
          deleteCommentToaster: "Komentarz został usunięty",
          deleteCommentMsg: "Czy na pewno chcesz usunąć ten Komentarz?",
          taxAlert: "Tax Alert",
          dateOfIssue: "Data wydania",
          latestConsolidatedDate: "Data ostatniej publikacji tekstu jednolitego",
        },
        adminPanel: {
          superadminTitle: "Panel Superadmina",
          notifications: "Powiadomienia",
          adminTitle: "Panel Administratora",
          manageUsersTab: "Zarządzaj Użytkownikami",
          uploadFilesTab: "Prześlij Pliki",
          userSettings: "Ustawienia Użytkownika",
          team: "Zespoły",
          addTeam: "Dodaj Zespół",
          editTeam: "Edytuj Zespół",
          deleteTeam: "Usuń Zespół",
          confirmMsgUser: "Czy na pewno chcesz usunąć tego użytkownika?",
          confirmMsgTeam: "Czy na pewno chcesz usunąć ten zespół?",
          cancel: "Anuluj",
          delete: "Usuń",
          searchInputPlaceholder: "Szukaj: imię, e-mail, rola, zespół",
          save: "Zapisz",
          deleteUser: "Usuń Użytkownika",
          removeTeam: "Usuń Użytkownika z Zespołu",
          deleteUserTeam:
            "Czy na pewno chcesz usunąć tego użytkownika z zespołu?",
          addUser: "Dodaj Użytkownika",
          add: "Dodaj",
          submit: "Zatwierdź",
          loading: "Ładowanie...",
          emailPlaceholder: "Podaj e-mail",
          singleUserMode: "Dodaj Pojedynczego Użytkownika",
          emailGroup: "Użyj Grupowego Emaila",
          emailGroupPlaceholder: "Podaj Grupę E-maili",
          noEmailsFound: "Nie znaleziono e-maili dla tej grupy.",
          invalidEmail: "Proszę wprowadzić poprawny adres e-mail.",
          columns: {
            name: "Imię",
            email: "E-mail",
            role: "Rola",
            team: "Zespół",
            editRole: "Edytuj Rolę",
            editTeam: "Edytuj Zespół",
          },
          createNewTeam: "Utwórz Nowy Zespół",
          adminUser: "Użytkownik Administratora",
          regulators: "Regulatorzy",
          teamName: "Nazwa Zespołu",
          otherTeamMembers: "Członkowie z Innego Zespołu",
          selectAdminUser: "Wybierz Użytkownika Administratora",
          selectRegulators: "Wybierz Regulatorów",
          teamNamePlaceholder: "Podaj Nazwę Zespołu",
          chatLimitPerUser: "Limit zapytań do czatu na użytkownika",
          teamMembers: "Członkowie Zespołu",
          roleChangeToaster: "Zmiana roli została zapisana",
          teamChangeToaster: "Zmiana zespołu została zapisana",
          addTeamToaster: "Zespół został dodany",
          editTeamToaster: "Zespół został edytowany",
          deleteTeamToaster: "Zespół został usunięty",
          addUserToaster: "Użytkownik został dodany",
          addUserListToaster: "Grupa użytkowników została dodana",
          promptLibrary: "Biblioteka promptów",
          addSuperuser: "Dodaj Superużytkownika",
          sortAz: "Sortuj A-Z",
          sortZa: "Sortuj Z-A",
          addRegulator: "Poproś O Regulatora",
          addRegulatorTitle: "Poproś O Nowego Regulatora",
          description: "Opis",
          descriptionPlaceholder: "Wprowadź opis",
          files: "Pliki",
          file: "Plik",
          addRegulatorToaster:
            "Formularz zgłoszeniowy dodania nowego regulatora został wysłany",
          fileDropFileTitle:
            "Kliknij lub przeciągnij pliki w to miejsce, aby je przesłać",
          acceptedFiles: "Akceptowane pliki:",
        },
        userSettings: {
          preferredFilters: "Preferowane Filtry",
          filtersInfoText:
            "Wybierz preferowane filtry, aby uzyskać spersonalizowane doświadczenie.",
          selectCountry: "Kraj",
          selectRegulator: "Nazwa regulatora",
          selectClass: "Klasa",
          noClass: "Nie znaleziono żadnych Klas. Wybierz Kraj lub Regulatora.",
          discardChangesBtn: "Odrzuć Zmiany",
          saveChangesToaster: "Twoje zmiany zostały zapisane",
          discardChangesToaster: "Twoje zmiany zostały odrzucone",
        },
        promptLibrary: {
          promptsTitle: "Prompty",
          prompts: "Moje Prompty",
          teamPrompts: "Prompty Zespołu",
          allPrompts: "Wszystkie Prompty",
          title: "Tytuł",
          text: "Tekst",
          team: "Zespół",
          addPrompts: "Dodaj Prompt",
          searchPrompt: "Szukaj: imię, e-mail, rola, zespół",
          editPrompt: "Edytuj Prompt",
          deletePrompt: "Usuń Prompt",
          promptChangeToaster: "Prompt został zaktualizowany",
          savePrompt: "Zapisz Prompt",
          deletePromptMsg: "Czy na pewno chcesz usunąć ten Prompt?",
          deletePromptToaster: "Prompt został usunięty",
          addPromptToaster: "Prompt został dodany",
          textPlaceholder: "Wprowadź Tekst",
          titlePlaceholder: "Wprowadź Tytuł",
          promptLibraryLink: "Zarządzaj promptami",
        },
        translateModal: {
          translatePageFrom:
            "Przetłumacz Decyzję, Krótkie Podsumowanie, Podsumowanie AI",
          translateTo: "Przetłumacz na",
          showOriginal: "Pokaż Oryginał",
          translate: "Przetłumacz",
          translationTooltip: "Tłumaczenie zakończone pomyślnie",
          selectedLang: "Tekst jest już w wybranym języku.",
        },
        newRecordModal: {
          saveNewRecordToaster: "Nowy rekord został dodany",
          addNewRecordTitle: "Dodaj Nowy Rekord",
          saveDraft: "Zapisywanie Szkicu...",
          caseNamePlaceholder: "Wprowadź Unikalną Nazwę Sprawy",
          date: "Data",
          tags: "Tagi",
          singleFileAllow: "Dozwolony Jest Tylko Jeden Plik",
          multipleFileAllow: "Dozwolone Jest Wiele Plików",
          fileRequiredError: "Wymagany Jest Przynajmniej Jeden Plik",
          linkPlaceholder: "Adres URL Musi Zaczynać Się Od Http/Https",
          back: "Wstecz",
          generateAIField: "Wygeneruj Pole Za Pomocą AI",
          shortSummary: "Krótkie Podsumowanie",
          provisionPlaceholder: "Podaj Postanowienia",
          step1: "Krok 1 z 3",
          step2: "Krok 2 z 3",
          step3: "Krok 3 z 3",
          shortSummaryTextTooltip:
            "Pole tekstowe nie może być puste, aby wygenerować pole Krótkie Podsumowanie przy użyciu AI",
          shortSummaryTooltip:
            "Pole Podsumowanie nie może być puste, aby wygenerować pole Krótkie Podsumowanie przy użyciu AI",
        },
        feedback: {
          shortSummary: "Krótkie Podsumowanie AI",
          class: "Problem z Klasyfikacją",
          chat: "Problem z AI Chat",
          wrongInfo: "Nieprawidłowe Informacje",
          other: "Inne",
          addFeedbackToaster: "Opinia została wysłana",
          feedbackTitle: "Zostaw Opinię",
          section: "Sekcja",
          comment: "Komentarz",
          files: "Pliki",
          cancel: "Anuluj",
          send: "Wyślij",
        },
        example: {
          title: "Przykład",
          example1Title: "Link do strony:",
          example2Title: "Szczegóły wyszukiwania/filtrowania:",
          example3Title: "Preferencje klasyfikacji:",
          example4Title: "Treść podsumowania wygenerowanego przez AI:",
          example5Title: "Dane kontaktowe:",
          example6Title: "Załączone zrzuty ekranu:",
          example2Text:
            "W formularzu wyszukiwania w „Soud” należy wybrać Naczelny Sąd Administracyjny „Nejvyšší správní soud”. W „Druh dokumentu” należy wybrać Rodzsudek jako typ dokumentu. Orzeczenia są wydawane i publikowane na stronie internetowej tego samego dnia.",
          example3Text1: "Sklasyfikuj monitorowane informacje według:",
          example3Text2: "1. Typ dokumentu: Decyzja, Opinia, Uchwała, Inne",
          example3Text3:
            "2. Własna klasyfikacja: Podatek od wartości dodanej, Cło, Podatek dochodowy od osób fizycznych.",
          example4Text:
            "Podsumowanie powinno zawierać przedmiot sprawy, argumenty stron oraz ostateczne rozstrzygnięcie sądu.",
          example5Team: "Zespół: Zespół Podatkowy",
          example5Email: "E-maile: example@deloittece.com",
          example5Text1: "Strona główna aktualizacji",
          example5Text2: "Formularz wyszukiwania z wybranymi filtrami",
          example5Text3: "Przykład strony z przefiltrowanymi wynikami",
        },
        instruction: {
          title: "Instrukcje",
          userTitle: "Drogi Użytkowniku,",
          text0:
            "Jeśli chcesz dodać regulator do monitorowania w Legal Insight Monitor, prosimy o podanie następujących szczegółów. Nasz specjalista skontaktuje się z Tobą w celu dalszych wyjaśnień.",
          text1:
            "Proszę podać adres URL oficjalnej strony internetowej regulatora.",
          text2:
            "Jeśli strona oferuje formularz wyszukiwania lub filtry, proszę opisać, jak zazwyczaj zawężasz interesujące Cię informacje (np. według typu dokumentu, słów kluczowych itp.).",
          text3: "Jak chciałbyś sklasyfikować monitorowane informacje?",
          text4:
            "Jakie kluczowe punkty lub dane powinny być uwzględnione w podsumowaniu generowanym przez AI dla każdego dokumentu lub aktualizacji?",
          text5:
            "Proszę podać nazwę zespołu i adresy e-mail, abyśmy mogli się z Tobą skontaktować w razie potrzeby dodatkowych informacji.",
          text6:
            "Aby lepiej zrozumieć strukturę strony internetowej regulatora, prosimy o dołączenie zrzutów ekranu odpowiednich stron lub formularzy wyszukiwania do swojego zgłoszenia.",
          bestRegards: "Z poważaniem,",
          codetTeam: "Zespół Legal Insight Monitor",
        },
        notification: {
          createNotification: "Utwórz Powiadomienie",
          active: "Aktywne",
          inactive: "Nieaktywne",
          subject: "Temat",
          team: "Zespół",
          regulators: "Regulatorzy",
          classes: "Klasy",
          schedule: "Harmonogram",
          status: "Status",
          all: "Wszystkie",
          days: "Dni tygodnia",
          time: "Czas",
          timezone: "Strefa czasowa",
          editNotification: "Edytuj Powiadomienie",
          deleteNotification: "Usuń Powiadomienie",
          deleteNotificationMsg: "Czy na pewno chcesz usunąć to Powiadomienie?",
          searchNotification: "Szukaj: imię, e-mail, rola, zespół",
          frequency: "Częstotliwość Powiadomień",
          recipients: "Odbiorcy",
          create: "Utwórz",
          step1: "Krok 1 z 2",
          step2: "Krok 2 z 2",
          notificationChangeToaster: "Powiadomienie zostało zaktualizowane",
          deleteNotificationToaster: "Powiadomienie zostało usunięte",
          addNotificationToaster: "Powiadomienie zostało dodane",
          searchAndSelectRecipients: "Wyszukaj i wybierz odbiorców...",
          searchAndSelectRegulator: "Wyszukaj i wybierz regulatora...",
          subjectPlaceholder: "Podaj Temat",
          allClasses: "Wszystkie klasy",
          selectAtLeastOneDay: "Wybierz co najmniej jeden Dzień",
          on: "Włączony",
          off: "Wyłączony",
        },
      },
    },
    cs: {
      translation: {
        welcome: "Vítejte na našich stránkách!",
        editTooltip: "Upravit",
        saveTooltip: "Uložit",
        button: "Změnit jazyk",
        tabs: {
          all: "Vše",
          important: "Důležité",
          favourite: "Oblíbené",
        },
        itemsPerPage: "Počet položek na stránku:",
        chatButton: "AI Chat",
        searchButton: "Hledat",
        aiLabel: "AI",
        darkMode: {
          light: "Světlý režim",
          dark: "Tmavý režim",
        },
        logOut: "Odhlásit se",
        switchLanguage: "Změnit jazyk",
        pagination: {
          next: "Další",
          previous: "Předchozí",
        },
        searchPlaceholder: "Hledat dokumenty...",
        searchPlaceholderTooltip:
          "Jedná se o sémantické vyhledávání — rozumí kontextu, takže výsledky se mohou shodovat, i když formulace není přesná.",
        selectPlaceholder: "Vyberte...",
        noData: "Žádná data nebyla nalezena",
        exportReport: "Exportovat",
        exportReportBlock: "Export (zakázáno). Nejsou vybráni žádní regulátoři",
        exportDocx: "Export do Docx (limit 300 záznamů)",
        exportExcel: "Export do Excel (limit 800 záznamů)",
        generateTaxAlertRo: "Vygenerovat Daňový Alert (RO)",
        generateTaxAlertEng: "Vygenerovat Daňový Alert (ENG)",
        errorExport: "Exportování zprávy se nezdařilo.",
        exportLoading: "Exportování…",
        exportSuccess: "Report byl úspěšně exportován",
        errorChatAIResponse: "AI Chat selhal. Zkuste to znovu",
        retryMessage: "Zkuste to znovu",
        switchThemes: "Přepnout motivy",
        downloadUserGuise: "Stáhnout „Legal Insight Monitor User Guide”",
        actions: "Akce",
        aiDisclaimer:
          "Legal Insight Monitor může dělat chyby nebo občas halucinovat. Před použitím prosím kriticky zkontrolujte výsledky.",
        filtersSection: {
          filters: "Filtry",
          clearFilters: "Vymazat filtry",
          country: "Země",
          regulatorName: "Zdroj",
          dateOfPublication: "Datum publikace",
          dateOfHearing: "/Slyšení",
          keywordsAndTags: "Klíčová slova a znaĝky",
          dateOfIssue: "Datum vydání",
          class: "Třída",
          setYesterdaysDate: "Nastavit Vĝerejší Datum",
          fromToPlaceholder: "Od - Do",
          searchAndSelectKeywords: "Vyhledejte a vyberte klíĝová slova...",
          searchAndSelectClass: "Vyhledejte a vyberte třídu...",
          searchAndSelectTags: "Vyhledejte a vyberte znaĝky...",
          searchAndSelectTechProduct:
            "Vyhledejte a vyberte technický produkt...",
          searchAndSelectTechSection: "Vyhledejte a vyberte technickou část...",
          searchAndSelectGazetteNumber:
            "Vyhledejte a vyberte číslo věstníku...",
          searchAndSelectJudges: "Vyhledejte a vyberte soudce...",
          searchAndSelectStatus: "Vyhledejte a vyberte stav...",
          searchAndSelectCity: "Vyhledejte a vyberte město...",
          searchAndSelectSubjectMatter: "Vyhledejte a vyberte předmět věci...",
          searchAndSelectTaxAlert: "Vyhledejte a vyberte tax alert...",
          from: "od:",
          until: "do:",
          techProduct: "Technický Produkt",
          techSectionVATAct: "Technická Část Zákona o DPH",
          gazetteNumber: "Číslo Věstníku",
          judges: "Soudci",
          status: "Stav",
          city: "Město",
          subjectMatter: "Předmět Věci",
        },
        tooltips: {
          remove: "Odstranit",
          addTag: "Přidat značku",
          openOriginalDocument: "Otevřít dokument",
        },
        docInfo: {
          dateOfPublication: "Datum publikace:",
          dateOfHearing: "Datum slyšení:",
          regulators: "Zdroje:",
          shortSummary: "Krátké Shrnutí AI:",
          class: "Třída:",
          confirmRemoveTag: "Opravdu chcete tento štítek smazat?",
          city: "Město:",
          judges: "Soudci:",
          status: "Stav:",
          techProduct: "Technický Produkt:",
          techSectionVATAct: "Technická Část Zákona o DPH:",
          gazetteNumber: "Číslo Věstníku:",
          taxAlert: "Tax Alert:",
        },
        chatAI: {
          askLegalQuestion: "Zeptejte se na právní otázku...",
          summaryDeleted: "Souhrn je oddělen od kontextu",
          howMayIHelp: "Jak vám mohu pomoci?",
          requestsLeftWarning: "Tento měsíc vám zbývá {{left}} požadavků na chat.",
          requestsLimitReached: "Tento měsíc jste vyčerpali všechny požadavky na chat.",
          summaryAdded: "Shrnutí je připojeno ke kontextu",
          unAttach: "Odpojit",
          savedPrompts: "Uložené Dotazy",
          outputAdjustments: "Formát výstupu",
          tone: "Tón",
          professional: "Profesionální",
          casual: "Neformální",
          simple: "Jednoduchý",
          format: "Formát",
          paragraph: "Odstavec",
          email: "E-mail",
          ideas: "Nápady",
          article: "Článek",
          length: "Délka",
          short: "Krátká",
          medium: "Střední",
          long: "Dlouhá",
          selectAll: "Chat s nejrelevantnějšími dokumenty",
          copyText: "Kopírovat text",
          exportChatConvTooltip: "Stáhnout konverzaci chatu",
          clearChatConvTooltip: "Vymazat konverzaci chatu",
          openOutputAdjTooltip: "Otevřít úpravy výstupu",
          openPromptLibraryTooltip: "Otevřít knihovnu promptů",
          closePromptLibraryTooltip: "Zavřít knihovnu promptů",
          copied: "Zkopírováno",
          edit: "Edit",
          editResponse: "Edit response",
          saveEdit: "Save",
          cancelEdit: "Cancel",
        },
        pdfViewer: {
          failedToLoad: "Nepodařilo se načíst dokument",
          failedToInitialize: "Nepodařilo se inicializovat prohlížeč PDF",
        },
        docDetails: {
          signature: "Podpis",
          comments: "Komentáře Týmu",
          information: "Informace",
          summary: "Shrnutí",
          chatAI: "Chat",
          caseName: "Název případu",
          dateOfPublication: "Datum publikace",
          dateOfHearing: "Datum slyšení",
          regulator: "Zdroj",
          class: "Třída",
          keywords: "Klíčová slova",
          participants: "Účastníci",
          provisions: "Ustanovení",
          decision: "Rozhodnutí",
          link: "Odkaz",
          shortSummary: "Krátké Shrnutí AI",
          copyToChatAI: "Zkopírovat do AI Chat",
          loadMore: "Načíst více",
          noResultsFound: "Nenalezeny žádné výsledky",
          saveDocInfoToaster: "Informace o dokumentu byly aktualizovány",
          teamSummary: "Shrnutí Týmu",
          aiSummary: "Shrnutí AI",
          copyToTeamSummary: "Kopírovat Do Shrnutí Týmu",
          lotusNotesLink: "Odkazy Na Soubory Lotus Notes",
          fetchDocLinkToaster:
            "Odkaz na soubor Lotus Notes byl úspěšně načten",
          city: "Město",
          officialGazetteNumber: "Číslo Sbírky Zákonů",
          title: "Název",
          promulgation: "Promulgace",
          subjectMatter: "Předmět Věci",
          text: "Text",
          techProduct: "Technický Produkt",
          techSectionVATAct: "Technická Část Zákona o DPH",
          gazetteNumber: "Číslo Věstníku",
          judges: "Soudci",
          status: "Stav",
          saveTeamSummary: "Souhrn týmu byl úspěšně uložen",
          commentsPlaceholder:
            "Přidejte komentář. Použijte @ k označení člena týmu.",
          addCommentToaster: "Komentář týmu byl úspěšně vytvořen",
          unsavedTitle: "Unsaved changes",
          unsavedBody:
            "You have unsaved summary changes. Discard them to switch tabs.",
          unsavedKeep: "Keep editing",
          unsavedDiscard: "Discard changes",
          noComment: "Zatím žádné komentáře...",
          deleteComment: "Smazat komentář",
          noMatches: "Žádné shody",
          editCommentToaster: "Komentář byl úspěšně aktualizován",
          deleteCommentToaster: "Komentář byl úspěšně smazán",
          deleteCommentMsg: "Opravdu chcete smazat tento Komentář?",
          taxAlert: "Tax Alert",
          dateOfIssue: "Datum vydání",
          latestConsolidatedDate: "Datum posledního konsolidovaného znění",
        },
        adminPanel: {
          superadminTitle: "Panel Superadmina",
          notifications: "Upozornění",
          adminTitle: "Administrátorský Panel",
          manageUsersTab: "Spravovat Uživatele",
          uploadFilesTab: "Nahrát Soubory",
          userSettings: "Nastavení Uživatele",
          editTeam: "Upravit Tým",
          deleteTeam: "Smazat Tým",
          confirmMsgUser: "Opravdu chcete odstranit tohoto uživatele?",
          confirmMsgTeam: "Opravdu chcete odstranit tento tým?",
          cancel: "Zrušit",
          delete: "Smazat",
          searchInputPlaceholder: "Hledat: jméno, e-mail, role, tým",
          save: "Uložit",
          deleteUser: "Smazat Uživatele",
          removeTeam: "Odebrat Uživatele z Týmu",
          deleteUserTeam: "Opravdu chcete odstranit tohoto uživatele z týmu?",
          addUser: "Přidat Uživatele",
          add: "Přidat",
          submit: "Odeslat",
          loading: "Načítání...",
          emailPlaceholder: "Zadejte e-mail",
          singleUserMode: "Přidat Jednotlivého Uživatele",
          emailGroup: "Použít Skupinový Email",
          emailGroupPlaceholder: "Zadejte Skupinu E-mailů",
          noEmailsFound:
            "Pro tuto skupinovou e-mailovou adresu nebyly nalezeny žádné e-maily.",
          invalidEmail: "Zadejte prosím platnou e-mailovou adresu.",
          columns: {
            name: "Jméno",
            email: "E-mail",
            role: "Role",
            team: "Tým",
            editRole: "Upravit Roli",
            editTeam: "Upravit Tým",
          },
          createNewTeam: "Vytvořit nový tým",
          adminUser: "Administrátorský uživatel",
          regulators: "Regulátory",
          teamName: "Název týmu",
          otherTeamMembers: "Členové z jiného týmu",
          selectAdminUser: "Vyberte administrátora",
          selectRegulators: "Vyberte regulátory",
          teamNamePlaceholder: "Zadejte název týmu",
          chatLimitPerUser: "Limit požadavků na chat na uživatele",
          teamMembers: "Členové týmu",
          roleChangeToaster: "Změna role byla úspěšně uložena",
          teamChangeToaster: "Změna týmu byla úspěšně uložena",
          addTeamToaster: "Tým byl úspěšně přidán",
          editTeamToaster: "Tým byl úspěšně upraven",
          deleteTeamToaster: "Tým byl úspěšně odstraněn",
          addUserToaster: "Uživatel byl úspěšně přidán",
          addUserListToaster: "Skupina uživatelů byla úspěšně přidána",
          promptLibrary: "Knihovna Podnětů",
          addSuperuser: "Přidat Superuživatele",
          sortAz: "Řadit A-Z",
          sortZa: "Řadit Z-A",
          addRegulator: "Požádat O Regulátora",
          addRegulatorTitle: "Požádat O Nového Regulátora",
          description: "Popis",
          descriptionPlaceholder: "Zadejte popis",
          files: "Soubory",
          file: "Soubor",
          addRegulatorToaster:
            "Formulář žádosti o přidání nového regulátora byl odeslán",
          fileDropFileTitle:
            "Klikněte nebo přetáhněte soubory do této oblasti pro nahrání",
          acceptedFiles: "Přijímané soubory:",
        },
        userSettings: {
          preferredFilters: "Preferované Filtry",
          filtersInfoText:
            "Vyberte si preferované filtry pro personalizovaný zážitek.",
          selectCountry: "Vyberte Zemi",
          selectRegulator: "Vyberte Regulátora",
          selectClass: "Vyberte Třídu",
          noClass: "Nebyla nalezena žádná Třída. Vyberte Zemi nebo Regulátora.",
          discardChangesBtn: "Zahodit Změny",
          saveChangesToaster: "Vaše změny byly uloženy",
          discardChangesToaster: "Vaše změny byly zahozeny",
        },
        promptLibrary: {
          promptsTitle: "Podněty",
          prompts: "Mé Podněty",
          teamPrompts: "Týmové Podněty",
          allPrompts: "Všechny Prompty",
          title: "Název",
          text: "Text",
          team: "Tým",
          addPrompts: "Přidat Podnět",
          searchPrompt: "Hledat: jméno, e-mail, role, tým",
          editPrompt: "Upravit Podnět",
          deletePrompt: "Smazat Podnět",
          promptChangeToaster: "Podnět byl úspěšně aktualizován",
          savePrompt: "Uložit Podnět",
          deletePromptMsg: "Opravdu chcete tento Podnět smazat?",
          deletePromptToaster: "Podnět byl úspěšně smazán",
          addPromptToaster: "Podnět byl úspěšně přidán",
          textPlaceholder: "Zadejte Text",
          titlePlaceholder: "Zadejte Název",
          promptLibraryLink: "Spravovat prompty",
        },
        translateModal: {
          translatePageFrom: "Přeložit Rozhodnutí, Krátké Shrnutí, Shrnutí AI",
          translateTo: "Přeložit do",
          showOriginal: "Zobrazit Originál",
          translate: "Přeložit",
          translationTooltip: "Překlad byl úspěšně dokončen",
          selectedLang: "Text je již ve vybraném jazyce.",
        },
        newRecordModal: {
          saveNewRecordToaster: "Nový záznam byl úspěšně přidán",
          addNewRecordTitle: "Přidat Nový Záznam",
          saveDraft: "Ukládání konceptu...",
          caseNamePlaceholder: "Zadejte jedinečný název případu",
          date: "Datum",
          tags: "Štítky",
          singleFileAllow: "Povolen pouze jeden soubor",
          multipleFileAllow: "Povoleno více souborů",
          fileRequiredError: "Je vyžadován alespoň jeden soubor",
          linkPlaceholder: "URL musí začínat http/https",
          back: "Zpět",
          generateAIField: "Vygenerovat pole pomocí AI",
          shortSummary: "Stručné Shrnutí",
          provisionPlaceholder: "Uveďte ustanovení",
          step1: "Krok 1 ze 3",
          step2: "Krok 2 ze 3",
          step3: "Krok 3 ze 3",
          shortSummaryTextTooltip:
            "Textové pole nesmí být prázdné pro vygenerování pole Stručné Shrnutí pomocí AI",
          shortSummaryTooltip:
            "Pole Shrnutí nesmí být prázdné pro vygenerování pole Stručné Shrnutí pomocí AI",
        },
        feedback: {
          shortSummary: "Stručné Shrnutí AI",
          class: "Problém s Klasifikací",
          chat: "Problém s AI Chat",
          wrongInfo: "Nesprávné Informace",
          other: "Jiné",
          addFeedbackToaster: "Zpětná vazba byla úspěšně odeslána",
          feedbackTitle: "Zanechte Zpětnou Vazbu",
          section: "Sekce",
          comment: "Komentář",
          files: "Soubory",
          cancel: "Zrušit",
          send: "Odeslat",
        },
        example: {
          title: "Příklad",
          example1Title: "Odkaz na web:",
          example2Title: "Podrobnosti vyhledávání/filtrování:",
          example3Title: "Preference klasifikace:",
          example4Title: "Obsah shrnutí vygenerovaného AI:",
          example5Title: "Kontaktní údaje:",
          example6Title: "Přiložené snímky obrazovky:",
          example2Text:
            "Ve vyhledávacím formuláři v „Soud” je potřeba vybrat Nejvyšší správní soud „Nejvyšší správní soud”. V „Druh dokumentu” je potřeba vybrat Rodzsudek jako typ dokumentu. Rozhodnutí jsou vydávána a zveřejňována na webu ve stejný den.",
          example3Text1: "Klasifikujte monitorované informace podle:",
          example3Text2:
            "1. Typ dokumentu: Rozhodnutí, Stanovisko, Usnesení, Jiné",
          example3Text3:
            "2. Vlastní klasifikace: Daň z přidané hodnoty, Clo, Daň z příjmů fyzických osob.",
          example4Text:
            "Shrnutí by mělo obsahovat předmět věci, argumenty stran a konečné rozhodnutí soudu.",
          example5Team: "Tým: Daňový Tým",
          example5Email: "E-maily: example@deloittece.com",
          example5Text1: "Hlavní stránka aktualizací",
          example5Text2: "Vyhledávací formulář s vybranými filtry",
          example5Text3: "Příklad stránky s filtrovanými výsledky",
        },
        instruction: {
          title: "Pokyny",
          userTitle: "Vážený Uživatel,",
          text0:
            "Pokud si přejete přidat regulátora ke sledování v Legal Insight Monitor, uveďte prosím následující údaje. Náš specialista Vás bude kontaktovat pro další upřesnění.",
          text1: "Uveďte prosím URL oficiálních webových stránek regulátora.",
          text2:
            "Pokud web nabízí vyhledávací formulář nebo filtry, popište prosím, jak obvykle zužujete informace, které Vás zajímají (např. podle typu dokumentu, klíčových slov atd.).",
          text3: "Jak byste chtěli klasifikovat sledované informace?",
          text4:
            "Jaké klíčové body nebo data by měla být zahrnuta do shrnutí generovaného AI pro každý dokument nebo aktualizaci?",
          text5:
            "Uveďte prosím název týmu a e-mailové adresy, abychom Vás mohli kontaktovat v případě potřeby dalších informací.",
          text6:
            "Abychom lépe porozuměli struktuře webu regulátora, přiložte prosím ke své žádosti snímky obrazovky příslušných stránek nebo vyhledávacích formulářů.",
          bestRegards: "S pozdravem,",
          codetTeam: "Tým Legal Insight Monitor",
        },
        notification: {
          createNotification: "Vytvořit Upozornění",
          active: "Aktivní",
          inactive: "Neaktivní",
          subject: "Předmět",
          team: "Tým",
          regulators: "Regulátoři",
          classes: "Třídy",
          schedule: "Plán",
          status: "Stav",
          all: "Vše",
          days: "Dny v týdnu",
          time: "Čas",
          timezone: "Časové pásmo",
          editNotification: "Upravit Upozornění",
          deleteNotification: "Smazat Upozornění",
          deleteNotificationMsg: "Opravdu chcete smazat toto Upozornění?",
          searchNotification: "Hledat: jméno, e-mail, role, tým",
          frequency: "Frekvence Upozornění",
          recipients: "Příjemci",
          create: "Vytvořit",
          step1: "Krok 1 ze 2",
          step2: "Krok 2 ze 2",
          notificationChangeToaster: "Upozornění bylo úspěšně aktualizováno",
          deleteNotificationToaster: "Upozornění bylo úspěšně smazáno",
          addNotificationToaster: "Upozornění bylo úspěšně přidáno",
          searchAndSelectRecipients: "Vyhledejte a vyberte příjemce...",
          searchAndSelectRegulator: "Vyhledejte a vyberte regulátora...",
          subjectPlaceholder: "Zadejte Předmět",
          allClasses: "Všechny třídy",
          selectAtLeastOneDay: "Vyberte alespoň jeden Den",
          on: "Zapnuto",
          off: "Vypnuto",
        },
      },
    },
    ro: {
      translation: {
        welcome: "Bun venit pe site-ul nostru!",
        editTooltip: "Editează",
        saveTooltip: "Salvează",
        button: "Schimbați limba",
        tabs: {
          all: "Toate",
          important: "Important",
          favourite: "Preferate",
        },
        itemsPerPage: "Elemente pe pagină:",
        chatButton: "AI Chat",
        searchButton: "Căutare",
        aiLabel: "AI",
        darkMode: {
          light: "Mod Luminos",
          dark: "Mod Întunecat",
        },
        logOut: "Deconectare",
        switchLanguage: "Schimbați limba",
        pagination: {
          next: "Următorul",
          previous: "Precedentul",
        },
        searchPlaceholder: "Caută documente...",
        searchPlaceholderTooltip:
          "Aceasta este o căutare semantică — înțelege contextul, astfel încât rezultatele pot corespunde chiar dacă formularea nu este precisă.",
        selectPlaceholder: "Selectează...",
        noData: "Nu au fost găsite date",
        exportReport: "Exportă",
        exportReportBlock:
          "Export (dezactivat). Nu au fost selectați niciunii regulatori",
        exportDocx: "Exportă în Docx (limită 300 de înregistrări)",
        exportExcel: "Exportă în Excel (limită 800 de înregistrări)",
        generateTaxAlertRo: "Generează Tax Alert (RO)",
        generateTaxAlertEng: "Generează Tax Alert (ENG)",
        errorExport: "Exportarea raportului a eșuat.",
        exportLoading: "Se exportă…",
        exportSuccess: "Raportul a fost exportat cu succes",
        errorChatAIResponse: "AI Chat a eșuat. Încercați din nou",
        retryMessage: "Încercați din nou",
        switchThemes: "Schimbă temele",
        downloadUserGuise: "Descarcă „Legal Insight Monitor User Guide”",
        actions: "Acțiuni",
        aiDisclaimer:
          "Legal Insight Monitor poate face greșeli sau ocazional poate halucina. Vă rugăm să analizați critic rezultatele înainte de a le folosi.",
        filtersSection: {
          filters: "Filtre",
          clearFilters: "Șterge filtrele",
          country: "Țară",
          regulatorName: "Sursă",
          dateOfPublication: "Data Publicării",
          dateOfHearing: "/Audierii",
          keywordsAndTags: "Cuvinte cheie și etichete",
          dateOfIssue: "Data Emiterii",
          class: "Clasă",
          setYesterdaysDate: "Setează data de ieri",
          fromToPlaceholder: "De la - Până la",
          searchAndSelectKeywords: "Căutați și selectați cuvinte cheie...",
          searchAndSelectClass: "Caută și selectează clasa...",
          searchAndSelectTags: "Căutați și selectați etichete...",
          searchAndSelectTechProduct: "Caută și selectează produsul tehnic...",
          searchAndSelectTechSection:
            "Caută și selectează secțiunea tehnică...",
          searchAndSelectGazetteNumber:
            "Caută și selectează numărul Monitorului Oficial...",
          searchAndSelectJudges: "Caută și selectează judecătorii...",
          searchAndSelectStatus: "Caută și selectează starea...",
          searchAndSelectCity: "Caută și selectează orașul...",
          searchAndSelectSubjectMatter:
            "Caută și selectează obiectul cauzei...",
          searchAndSelectTaxAlert: "Caută și selectează tax alert...",
          from: "de la:",
          until: "până la:",
          techProduct: "Produs Tehnic",
          techSectionVATAct: "Secțiunea Tehnică din Legea TVA",
          gazetteNumber: "Număr Monitor Oficial",
          judges: "Judecători",
          status: "Stare",
          city: "Oraș",
          subjectMatter: "Obiectul Cauzei",
        },
        tooltips: {
          remove: "Elimină",
          addTag: "Adaugă etichetă",
          openOriginalDocument: "Deschide documentul",
        },
        docInfo: {
          dateOfPublication: "Data Publicării:",
          dateOfHearing: "Data Audierii:",
          regulators: "Sursă:",
          shortSummary: "Rezumat AI Scurt:",
          class: "Clasă:",
          confirmRemoveTag: "Sigur vrei să ștergi acest tag?",
          city: "Stare:",
          judges: "Stare:",
          status: "Stare:",
          techProduct: "Produs Tehnic:",
          techSectionVATAct: "Secțiunea Tehnică din Legea TVA:",
          gazetteNumber: "Număr Monitor Oficial:",
          taxAlert: "Tax Alert:",
        },
        chatAI: {
          askLegalQuestion: "Pune o întrebare juridică...",
          summaryDeleted: "Rezumatul este detașat de context",
          howMayIHelp: "Cu ce vă pot ajuta?",
          requestsLeftWarning: "Mai aveți {{left}} solicitări de chat în această lună.",
          requestsLimitReached: "Ați folosit toate solicitările de chat din această lună.",
          summaryAdded: "Rezumatul este atașat contextului",
          unAttach: "Detașează",
          savedPrompts: "Sugestii salvate",
          outputAdjustments: "Format de iesire",
          tone: "Ton",
          professional: "Profesional",
          casual: "Lejer",
          simple: "Simplu",
          format: "Format",
          paragraph: "Paragraf",
          email: "E-mail",
          ideas: "Idei",
          article: "Articol",
          length: "Lungime",
          short: "Scurt",
          medium: "Mediu",
          long: "Lung",
          selectAll: "Chat cu cele mai relevante documente",
          copyText: "Copiază textul",
          exportChatConvTooltip: "Descarcă conversația din chat",
          clearChatConvTooltip: "Șterge conversația din chat",
          openOutputAdjTooltip: "Deschide ajustările rezultatului",
          openPromptLibraryTooltip: "Deschide biblioteca de prompturi",
          closePromptLibraryTooltip: "Închide biblioteca de prompturi",
          copied: "Copiat",
          edit: "Edit",
          editResponse: "Edit response",
          saveEdit: "Save",
          cancelEdit: "Cancel",
        },
        pdfViewer: {
          failedToLoad: "Eșec la încărcarea documentului",
          failedToInitialize: "Eșec la inițializarea vizualizatorului PDF",
        },
        docDetails: {
          signature: "Semnătură",
          comments: "Comentarii ale Echipei",
          information: "Informații",
          summary: "Rezumat",
          chatAI: "Chat",
          caseName: "Numele cazului",
          dateOfPublication: "Data Publicării",
          dateOfHearing: "Data audierii",
          regulator: "Sursă",
          class: "Clasă",
          keywords: "Cuvinte cheie",
          participants: "Participanți",
          provisions: "Prevederi",
          decision: "Decizie",
          link: "Link",
          shortSummary: "Rezumat AI Scurt",
          copyToChatAI: "Copiați în AI Chat",
          loadMore: "Încarcă mai mult",
          noResultsFound: "Nu s-au găsit rezultate",
          saveDocInfoToaster: "Informațiile documentului au fost actualizate",
          teamSummary: "Sumarul Echipei",
          aiSummary: "Sumar AI",
          copyToTeamSummary: "Copiază În Sumarul Echipei",
          lotusNotesLink: "Linkuri Fișiere Lotus Notes",
          fetchDocLinkToaster:
            "Linkul fișierului Lotus Notes a fost preluat cu succes",
          city: "Oraș",
          officialGazetteNumber: "Număr Monitor Oficial",
          title: "Titlu",
          promulgation: "Promulgare",
          subjectMatter: "Obiectul Cauzei",
          text: "Text",
          techProduct: "Produs Tehnic",
          techSectionVATAct: "Secțiunea Tehnică din Legea TVA",
          gazetteNumber: "Număr Monitor Oficial",
          judges: "Judecători",
          status: "Stare",
          saveTeamSummary: "Rezumatul echipei a fost salvat cu succes",
          commentsPlaceholder:
            "Adaugă un comentariu. Folosește @ pentru a menționa un membru al echipei.",
          addCommentToaster: "Comentariul echipei a fost creat cu succes",
          unsavedTitle: "Unsaved changes",
          unsavedBody:
            "You have unsaved summary changes. Discard them to switch tabs.",
          unsavedKeep: "Keep editing",
          unsavedDiscard: "Discard changes",
          noComment: "Niciun comentariu încă...",
          deleteComment: "Șterge comentariul",
          noMatches: "Nicio potrivire",
          editCommentToaster: "Comentariul a fost actualizat cu succes",
          deleteCommentToaster: "Comentariul a fost șters cu succes",
          deleteCommentMsg: "Sigur doriți să ștergeți acest Comentariu?",
          taxAlert: "Tax Alert",
          dateOfIssue: "Data emiterii",
          latestConsolidatedDate: "Data ultimei publicări consolidate",
        },
        adminPanel: {
          superadminTitle: "Panoul Superadminului",
          notifications: "Notificări",
          adminTitle: "Panou de Administrare",
          manageUsersTab: "Gestionați utilizatorii",
          uploadFilesTab: "Încărcați fișiere",
          userSettings: "Setări utilizator",
          team: "Echipe",
          addTeam: "Adăugați echipă",
          editTeam: "Editați echipă",
          deleteTeam: "Ștergeți echipă",
          confirmMsgUser: "Sigur doriți să ștergeți acest utilizator?",
          confirmMsgTeam: "Sigur doriți să ștergeți această echipă?",
          cancel: "Anulați",
          delete: "Ștergeți",
          searchInputPlaceholder: "Căutare: nume, e-mail, rol, echipă",
          save: "Salvați",
          deleteUser: "Șterge utilizator",
          removeTeam: "Elimină utilizatorul din echipă",
          deleteUserTeam:
            "Sigur doriți să ștergeți acest utilizator din Echipă?",
          addUser: "Adaugă Utilizator",
          add: "Adaugă",
          submit: "Trimite",
          loading: "Se încarcă...",
          emailPlaceholder: "Introduceți e-mail",
          singleUserMode: "Adaugă Utilizator Unic",
          emailGroup: "Folosește Email de Grup",
          emailGroupPlaceholder: "Introduceți grupul de e-mailuri",
          noEmailsFound: "Nu s-au găsit e-mailuri pentru acest grup.",
          invalidEmail: "Vă rugăm să introduceți o adresă de e-mail validă.",
          columns: {
            name: "Nume",
            email: "E-mail",
            role: "Rol",
            team: "Echipă",
            editRole: "Editează rolul",
            editTeam: "Editează echipa",
          },
          createNewTeam: "Creează echipă nouă",
          adminUser: "Utilizator administrator",
          regulators: "Regulatori",
          teamName: "Numele echipei",
          otherTeamMembers: "Membri din altă echipă",
          selectAdminUser: "Selectați utilizatorul administrator",
          selectRegulators: "Selectați regulatori",
          teamNamePlaceholder: "Introduceți numele echipei",
          chatLimitPerUser: "Limita de solicitări de chat per utilizator",
          teamMembers: "Membrii echipei",
          roleChangeToaster: "Modificarea rolului a fost salvată cu succes",
          teamChangeToaster: "Modificarea echipei a fost salvată cu succes",
          addTeamToaster: "Echipa a fost adăugată cu succes",
          editTeamToaster: "Echipa a fost editată cu succes",
          deleteTeamToaster: "Echipa a fost ștearsă cu succes",
          addUserToaster: "Utilizatorul a fost adăugat cu succes",
          addUserListToaster: "Grupul de utilizatori a fost adăugat cu succes",
          addSuperuser: "Adaugă Superutilizator",
          sortAz: "Sortează A-Z",
          sortZa: "Sortează Z-A",
          addRegulator: "Solicită Regulator",
          addRegulatorTitle: "Solicită Un Nou Regulator",
          description: "Descriere",
          descriptionPlaceholder: "Introdu descrierea",
          files: "Fișiere",
          file: "Fișier",
          addRegulatorToaster:
            "Formularul de solicitare pentru adăugarea unui nou regulator a fost trimis",
          fileDropFileTitle:
            "Fă clic sau trage fișierele în această zonă pentru a le încărca",
          acceptedFiles: "Fișiere acceptate:",
        },
        userSettings: {
          preferredFilters: "Filtre Preferate",
          filtersInfoText:
            "Selectați filtrele preferate pentru o experiență personalizată.",
          selectCountry: "Selectați Țara",
          selectRegulator: "Selectați Regulatorul",
          selectClass: "Selectați Clasa",
          noClass:
            "Nu a fost găsită nicio Clasă. Selectați o Țară sau un Regulator.",
          discardChangesBtn: "Renunță la Modificări",
          saveChangesToaster: "Modificările tale au fost salvate",
          discardChangesToaster: "Modificările tale au fost anulate",
        },
        promptLibrary: {
          promptsTitle: "Prompturile",
          prompts: "Prompturile Mele",
          teamPrompts: "Prompturile Echipei",
          allPrompts: "Toate Prompturile",
          title: "Titlu",
          text: "Text",
          team: "Echipă",
          addPrompts: "Adaugă Prompt",
          searchPrompt: "Căutare: nume, e-mail, rol, echipă",
          editPrompt: "Editează Promptul",
          deletePrompt: "Șterge Promptul",
          promptChangeToaster: "Promptul a fost actualizat cu succes",
          savePrompt: "Salvează Prompt",
          deletePromptMsg: "Sigur doriți să ștergeți acest Prompt?",
          deletePromptToaster: "Promptul a fost șters cu succes",
          addPromptToaster: "Promptul a fost adăugat cu succes",
          textPlaceholder: "Introduceți Text",
          titlePlaceholder: "Introduceți Titlul",
          promptLibraryLink: "Gestionează prompturile",
        },
        translateModal: {
          translatePageFrom: "Traduce Decizia, Rezumatul Scurt, Rezumatul AI",
          translateTo: "Traduce în",
          showOriginal: "Afișează Originalul",
          translate: "Traduce",
          translationTooltip: "Traducerea a fost realizată cu succes",
          selectedLang: "Textul este deja în limba selectată.",
        },
        newRecordModal: {
          saveNewRecordToaster: "Înregistrarea nouă a fost adăugată cu succes",
          addNewRecordTitle: "Adaugă Înregistrare Nouă",
          saveDraft: "Se salvează schița...",
          caseNamePlaceholder: "Introduceți un nume unic pentru caz",
          date: "Dată",
          tags: "Etichete",
          singleFileAllow: "Este permis doar un singur fișier",
          multipleFileAllow: "Sunt permise mai multe fișiere",
          fileRequiredError: "Este necesar cel puțin un fișier",
          linkPlaceholder: "URL trebuie să înceapă cu http/https",
          back: "Înapoi",
          generateAIField: "Generează câmp folosind AI",
          shortSummary: "Rezumat Scurt",
          provisionPlaceholder: "Furnizați prevederi",
          step1: "Pasul 1 din 3",
          step2: "Pasul 2 din 3",
          step3: "Pasul 3 din 3",
          shortSummaryTextTooltip:
            "Câmpul text nu poate fi gol pentru a genera câmpul Rezumat Scurt folosind AI",
          shortSummaryTooltip:
            "Câmpul Rezumat nu poate fi gol pentru a genera câmpul Rezumat Scurt folosind AI",
        },
        feedback: {
          shortSummary: "Rezumat Scurt AI",
          class: "Problemă de Clasificare",
          chat: "Problemă AI Chat",
          wrongInfo: "Informații Greșite",
          other: "Altele",
          addFeedbackToaster: "Feedback-ul a fost trimis cu succes",
          feedbackTitle: "Lasă un Feedback",
          section: "Secțiune",
          comment: "Comentariu",
          files: "Fișiere",
          cancel: "Anulează",
          send: "Trimite",
        },
        example: {
          title: "Exemplu",
          example1Title: "Link către site:",
          example2Title: "Detalii de căutare/filtrare:",
          example3Title: "Preferințe de clasificare:",
          example4Title: "Conținut rezumat generat de AI:",
          example5Title: "Date de contact:",
          example6Title: "Capturi de ecran atașate:",
          example2Text:
            "În formularul de căutare din „Soud” trebuie să selectați Curtea Administrativă Supremă „Nejvyšší správní soud”. În „Druh dokumentu” trebuie să selectați Rodzsudek ca tip de document. Deciziile sunt emise și publicate pe site în aceeași zi.",
          example3Text1: "Clasificați informațiile monitorizate după:",
          example3Text2:
            "1. Tip de document: Decizie, Opinie, Hotărâre, Altele",
          example3Text3:
            "2. Clasificare personalizată: Taxa pe valoarea adăugată, Vamă, Impozitul pe venitul personal.",
          example4Text:
            "Rezumatul ar trebui să includă obiectul cauzei, argumentele părților și decizia finală a instanței.",
          example5Team: "Echipă: Echipă Fiscală",
          example5Email: "Emailuri: example@deloittece.com",
          example5Text1: "Pagina principală de actualizări",
          example5Text2: "Formular de căutare cu filtre selectate",
          example5Text3: "Exemplu de pagină cu rezultate filtrate",
        },
        instruction: {
          title: "Instrucțiuni",
          userTitle: "Stimate Utilizator,",
          text0:
            "Dacă doriți să adăugați un regulator pentru monitorizare în Legal Insight Monitor, vă rugăm să furnizați următoarele detalii. Specialistul nostru vă va contacta pentru clarificări suplimentare.",
          text1:
            "Vă rugăm să furnizați URL-ul site-ului oficial al regulatorului.",
          text2:
            "Dacă site-ul oferă un formular de căutare sau filtre, vă rugăm să descrieți cum restrângeți de obicei informațiile care vă interesează (de exemplu, după tipul documentului, după cuvinte cheie etc.).",
          text3: "Cum ați dori să clasificați informațiile monitorizate?",
          text4:
            "Ce puncte cheie sau date ar trebui incluse în rezumatul generat de AI pentru fiecare document sau actualizare?",
          text5:
            "Vă rugăm să furnizați numele echipei și adresele de e-mail pentru a putea lua legătura cu dvs. dacă avem nevoie de informații suplimentare.",
          text6:
            "Pentru a ne ajuta să înțelegem mai bine structura site-ului regulatorului, vă rugăm să atașați capturi de ecran ale paginilor relevante sau ale formularelor de căutare la cererea dvs.",
          bestRegards: "Cu stimă,",
          codetTeam: "Echipa Legal Insight Monitor",
        },
        notification: {
          createNotification: "Creează Notificare",
          active: "Activ",
          inactive: "Inactiv",
          subject: "Subiect",
          team: "Echipă",
          regulators: "Regulatori",
          classes: "Clase",
          schedule: "Program",
          status: "Stare",
          all: "Toate",
          days: "Zilele săptămânii",
          time: "Oră",
          timezone: "Fus orar",
          editNotification: "Editează Notificarea",
          deleteNotification: "Șterge Notificarea",
          deleteNotificationMsg: "Sigur doriți să ștergeți această Notificare?",
          searchNotification: "Căutare: nume, e-mail, rol, echipă",
          frequency: "Frecvența Notificărilor",
          recipients: "Destinatari",
          create: "Creează",
          step1: "Pasul 1 din 2",
          step2: "Pasul 2 din 2",
          notificationChangeToaster: "Notificarea a fost actualizată cu succes",
          deleteNotificationToaster: "Notificarea a fost ștearsă cu succes",
          addNotificationToaster: "Notificarea a fost adăugată cu succes",
          searchAndSelectRecipients: "Caută și selectează destinatarii...",
          searchAndSelectRegulator: "Caută și selectează regulatorul...",
          subjectPlaceholder: "Introduceți Subiectul",
          allClasses: "Toate clasele",
          selectAtLeastOneDay: "Selectați cel puțin o Zi",
          on: "Activat",
          off: "Dezactivat",
        },
      },
    },
    hu: {
      translation: {
        welcome: "Üdvözöljük a weboldalunkon!",
        editTooltip: "Szerkesztés",
        saveTooltip: "Mentés",
        button: "Nyelv váltása",
        tabs: {
          all: "Összes",
          important: "Fontos",
          favourite: "Kedvenc",
        },
        itemsPerPage: "Elemek száma oldalanként:",
        chatButton: "AI Chat",
        searchButton: "Keresés",
        aiLabel: "AI",
        darkMode: {
          light: "Világos mód",
          dark: "Sötét mód",
        },
        logOut: "Kijelentkezés",
        switchLanguage: "Nyelv váltása",
        pagination: {
          next: "Következő",
          previous: "Előző",
        },
        searchPlaceholder: "Dokumentumok keresése...",
        searchPlaceholderTooltip:
          "Ez egy szemantikus keresés — érti a kontextust, így az eredmények akkor is egyezhetnek, ha a megfogalmazás nem pontos.",
        selectPlaceholder: "Válassz...",
        noData: "Nincs találat",
        exportReport: "Exportálás",
        exportReportBlock:
          "Exportálás (letiltva). Nincsenek kiválasztva szabályozók",
        exportDocx: "Exportálás Docx-be (300 rekord korlát)",
        exportExcel: "Exportálás Excel-be (800 rekord korlát)",
        generateTaxAlertRo: "Adóriasztás Létrehozása (RO)",
        generateTaxAlertEng: "Adóriasztás Létrehozása (ENG)",
        errorExport: "A jelentés exportálása sikertelen volt.",
        exportLoading: "Exportálás…",
        exportSuccess: "A jelentés sikeresen exportálva",
        errorChatAIResponse: "A AI Chat nem sikerült. Próbálja újra",
        retryMessage: "Próbálja újra",
        switchThemes: "Témák váltása",
        downloadUserGuise: "Letöltés „Legal Insight Monitor User Guide”",
        actions: "Műveletek",
        aiDisclaimer:
          "A Legal Insight Monitor hibázhat vagy esetenként hallucinálhat. Kérjük, kritikusan tekintse át az eredményeket, mielőtt felhasználná őket.",
        filtersSection: {
          filters: "Szűrők",
          clearFilters: "Szűrők törlése",
          country: "Ország",
          regulatorName: "Forrás",
          dateOfPublication: "Közzététel dátuma",
          dateOfHearing: "/Meghallgatás",
          keywordsAndTags: "Kulcsszavak és címkék",
          dateOfIssue: "Kiadás dátuma",
          class: "Osztály",
          setYesterdaysDate: "Tegnap Dátumának Beállítása",
          fromToPlaceholder: "-tól -ig",
          searchAndSelectKeywords: "Kulcsszavak keresése és kiválasztása...",
          searchAndSelectClass: "Osztály keresése és kiválasztása...",
          searchAndSelectTags: "Címkék keresése és kiválasztása...",
          searchAndSelectTechProduct:
            "Technikai termék keresése és kiválasztása...",
          searchAndSelectTechSection:
            "Technikai szakasz keresése és kiválasztása...",
          searchAndSelectGazetteNumber:
            "Közlöny számának keresése és kiválasztása...",
          searchAndSelectJudges: "Bírák keresése és kiválasztása...",
          searchAndSelectStatus: "Állapot keresése és kiválasztása...",
          searchAndSelectCity: "Város keresése és kiválasztása...",
          searchAndSelectSubjectMatter: "Tárgy keresése és kiválasztása...",
          searchAndSelectTaxAlert: "Keresés és tax alert kiválasztása...",
          from: "-tól:",
          until: "-ig:",
          techProduct: "Technikai Termék",
          techSectionVATAct: "ÁFA Törvény Technikai Szakasza",
          gazetteNumber: "Közlöny Száma",
          judges: "Bírák",
          status: "Állapot",
          city: "Város",
          subjectMatter: "Tárgy",
        },
        tooltips: {
          remove: "Eltávolítás",
          addTag: "Címke hozzáadása",
          openOriginalDocument: "Dokumentum megnyitása",
        },
        docInfo: {
          dateOfPublication: "Közzététel dátuma:",
          dateOfHearing: "Meghallgatás Dátuma:",
          regulators: "Források:",
          shortSummary: "Rövid AI Összefoglaló:",
          class: "Osztály:",
          confirmRemoveTag: "Biztosan törölni szeretnéd ezt a címkét?",
          city: "Város:",
          judges: "Bírák:",
          status: "Ýllapot:",
          techProduct: "Technikai Termék:",
          techSectionVATAct: "ÝFA Törvény Technikai Szakasza:",
          gazetteNumber: "Közlöny Száma:",
          taxAlert: "Adóriasztás:",
        },
        chatAI: {
          askLegalQuestion: "Tegyen fel jogi kérdést...",
          summaryDeleted: "Az összefoglaló el van választva a kontextustól",
          howMayIHelp: "Hogyan segíthetek?",
          requestsLeftWarning: "Ebben a hónapban még {{left}} csevegési kérése van hátra.",
          requestsLimitReached: "Ebben a hónapban felhasználta az összes csevegési kérését.",
          summaryAdded: "Az összefoglaló a kontextushoz van csatolva",
          unAttach: "Leválaszt",
          savedPrompts: "Elmentett kérdések",
          outputAdjustments: "Kimeneti formatum",
          tone: "Hangnem",
          professional: "Professzionális",
          casual: "Kötetlen",
          simple: "Egyszerű",
          format: "Formátum",
          paragraph: "Bekezdés",
          email: "E-mail",
          ideas: "Ötletek",
          article: "Cikk",
          length: "Hossz",
          short: "Rövid",
          medium: "Közepes",
          long: "Hosszú",
          selectAll: "Csevegés a legrelevánsabb dokumentumokkal",
          copyText: "Szöveg másolása",
          exportChatConvTooltip: "Csevegés letöltése",
          clearChatConvTooltip: "Csevegés törlése",
          openOutputAdjTooltip: "Kimenet beállításainak megnyitása",
          openPromptLibraryTooltip: "Promptkönyvtár megnyitása",
          closePromptLibraryTooltip: "Promptkönyvtár bezárása",
          copied: "Másolva",
          edit: "Edit",
          editResponse: "Edit response",
          saveEdit: "Save",
          cancelEdit: "Cancel",
        },
        pdfViewer: {
          failedToLoad: "Nem sikerült betölteni a dokumentumot",
          failedToInitialize: "Nem sikerült inicializálni a PDF megjelenítőt",
        },
        docDetails: {
          signature: "Aláírás",
          comments: "Megjegyzések",
          information: "Információ",
          summary: "Összefoglaló",
          chatAI: "Chat",
          caseName: "Ügy neve",
          dateOfPublication: "Közzététel dátuma",
          dateOfHearing: "Meghallgatás dátuma",
          regulator: "Forrás",
          class: "Osztály",
          keywords: "Kulcsszavak",
          participants: "Résztvevők",
          provisions: "Rendelkezések",
          decision: "Döntés",
          link: "Link",
          shortSummary: "Rövid AI Összefoglaló",
          copyToChatAI: "Másolás a AI Chat-hez",
          loadMore: "További betöltése",
          noResultsFound: "Nincs találat",
          saveDocInfoToaster: "A dokumentum adatai frissítve lettek",
          teamSummary: "Csapat összefoglaló",
          aiSummary: "AI Összefoglaló",
          copyToTeamSummary: "Másolás A Csapatösszegzésbe",
          lotusNotesLink: "Lotus Notes fájlhivatkozások",
          fetchDocLinkToaster:
            "A Lotus Notes fájlhivatkozás sikeresen lekérve",
          city: "Város",
          officialGazetteNumber: "Hivatalos Közlöny Száma",
          title: "Cím",
          promulgation: "Közzététel",
          subjectMatter: "Tárgy",
          text: "Szöveg",
          techProduct: "Technikai Termék",
          techSectionVATAct: "ÁFA Törvény Technikai Szakasza",
          gazetteNumber: "Közlöny Száma",
          judges: "Bírák",
          status: "Állapot",
          saveTeamSummary: "A csapatösszefoglaló sikeresen elmentve",
          commentsPlaceholder:
            "Adj hozzá megjegyzést. Használd a @ jelet a csapattag megemlítéséhez.",
          addCommentToaster: "A csapat megjegyzése sikeresen létrehozva",
          unsavedTitle: "Unsaved changes",
          unsavedBody:
            "You have unsaved summary changes. Discard them to switch tabs.",
          unsavedKeep: "Keep editing",
          unsavedDiscard: "Discard changes",
          noComment: "Még nincsenek megjegyzések...",
          deleteComment: "Megjegyzés törlése",
          noMatches: "Nincs találat",
          editCommentToaster: "A megjegyzés sikeresen frissítve lett",
          deleteCommentToaster: "A megjegyzés sikeresen törölve lett",
          deleteCommentMsg: "Biztosan törölni szeretné ezt a Megjegyzést?",
          taxAlert: "Adóriasztás",
          dateOfIssue: "Kiadás dátuma",
          latestConsolidatedDate: "Legutolsó konszolidált közzététel dátuma",
        },
        adminPanel: {
          superadminTitle: "Szuperadminisztrátori Panel",
          notifications: "Értesítések",
          adminTitle: "Adminisztrációs Panel",
          manageUsersTab: "Felhasználók kezelése",
          uploadFilesTab: "Fájlok feltöltése",
          userSettings: "Felhasználói beállítások",
          team: "Csapatok",
          addTeam: "Csapat hozzáadása",
          editTeam: "Csapat szerkesztése",
          deleteTeam: "Csapat törlése",
          confirmMsgUser: "Biztosan törölni szeretné ezt a felhasználót?",
          confirmMsgTeam: "Biztosan törölni szeretné ezt a csapatot?",
          cancel: "Mégse",
          delete: "Törlés",
          searchInputPlaceholder: "Keresés: név, e-mail, szerep, csapat",
          save: "Mentés",
          deleteUser: "Felhasználó törlése",
          removeTeam: "Felhasználó eltávolítása a csapatból",
          deleteUserTeam:
            "Biztosan törölni szeretné ezt a felhasználót a csapatból?",
          addUser: "Felhasználó Hozzáadása",
          add: "Hozzáadás",
          submit: "Beküldés",
          loading: "Betöltés...",
          emailPlaceholder: "Adja meg az e-mail címet",
          singleUserMode: "Egyetlen Felhasználó Hozzáadása",
          emailGroup: "Csoportos Email Használata",
          emailGroupPlaceholder: "Adja meg a csoport e-mailjeit",
          noEmailsFound: "Nem találhatók e-mailek ehhez a csoporthoz.",
          invalidEmail: "Kérjük, adjon meg egy érvényes e-mail címet.",
          columns: {
            name: "Név",
            email: "E-mail",
            role: "Szerep",
            team: "Csapat",
            editRole: "Szerep szerkesztése",
            editTeam: "Csapat szerkesztése",
          },
          createNewTeam: "Új csapat létrehozása",
          adminUser: "Adminisztrátor felhasználó",
          regulators: "Szabályozók",
          teamName: "Csapat neve",
          otherTeamMembers: "Tagok más csapatból",
          selectAdminUser: "Adminisztrátor kiválasztása",
          selectRegulators: "Szabályozók kiválasztása",
          teamNamePlaceholder: "Adja meg a csapat nevét",
          chatLimitPerUser: "Csevegési kérések korlátja felhasználónként",
          teamMembers: "Csapattagok",
          roleChangeToaster: "A szerep módosítása sikeresen mentve",
          teamChangeToaster: "A csapat módosítása sikeresen mentve",
          addTeamToaster: "A csapat sikeresen hozzáadva",
          editTeamToaster: "A csapat sikeresen szerkesztve",
          deleteTeamToaster: "A csapat sikeresen törölve",
          addUserToaster: "A felhasználó sikeresen hozzáadva",
          addUserListToaster: "A felhasználói csoport sikeresen hozzáadva",
          promptLibrary: "Prompt Könyvtár",
          addSuperuser: "Szuperfelhasználó Hozzáadása",
          sortAz: "Rendezés A-Z",
          sortZa: "Rendezés Z-A",
          addRegulator: "Szabályozó Kérése",
          addRegulatorTitle: "Új Szabályozó Kérése",
          description: "Leírás",
          descriptionPlaceholder: "Adja meg a leírást",
          files: "Fájlok",
          file: "Fájl",
          addRegulatorToaster: "A kérelem új szabályozó hozzáadására elküldve",
          fileDropFileTitle: "Kattints vagy húzd ide a fájlokat a feltöltéshez",
          acceptedFiles: "Elfogadott fájlok:",
        },
        userSettings: {
          preferredFilters: "Preferált Szűrők",
          filtersInfoText:
            "Válassza ki a preferált szűrőket a személyre szabott élményhez.",
          selectCountry: "Válassz Országot",
          selectRegulator: "Válassz Szabályozót",
          selectClass: "Válassz Osztályt",
          noClass:
            "Nem található Osztály. Kérlek, válassz egy Országot vagy Szabályozót.",
          discardChangesBtn: "Változtatások Elvetése",
          saveChangesToaster: "A módosításaid elmentve",
          discardChangesToaster: "A módosításaid elvetve",
        },
        promptLibrary: {
          promptsTitle: "Promptek",
          prompts: "Saját Promptek",
          teamPrompts: "Csapat Promptek",
          allPrompts: "Összes Promptek",
          title: "Cím",
          text: "Szöveg",
          team: "Csapat",
          addPrompts: "Prompt Hozzáadása",
          searchPrompt: "Keresés: név, e-mail, szerep, csapat",
          editPrompt: "Prompt Szerkesztése",
          deletePrompt: "Prompt Törlése",
          promptChangeToaster: "A prompt sikeresen frissítve lett",
          savePrompt: "Prompt Mentése",
          deletePromptMsg: "Biztosan törölni szeretné ezt a Promptot?",
          deletePromptToaster: "A prompt sikeresen törölve lett",
          addPromptToaster: "A prompt sikeresen hozzáadva",
          textPlaceholder: "Adja Meg A Szöveget",
          titlePlaceholder: "Adja Meg A Címet",
          promptLibraryLink: "Promptok kezelése",
        },
        translateModal: {
          translatePageFrom:
            "Döntés, Rövid Összefoglaló, AI Összefoglaló fordítása",
          translateTo: "Fordítás erre a nyelvre",
          showOriginal: "Eredeti Megjelenítése",
          translate: "Fordítás",
          translationTooltip: "A fordítás sikeresen elkészült",
          selectedLang: "A szöveg már a kiválasztott nyelven van.",
        },
        newRecordModal: {
          saveNewRecordToaster: "Az új rekord sikeresen hozzáadva",
          addNewRecordTitle: "Új Rekord Hozzáadása",
          saveDraft: "Piszkozat mentése...",
          caseNamePlaceholder: "Adjon meg egy egyedi esetnevet",
          date: "Dátum",
          tags: "Címkék",
          singleFileAllow: "Csak egy fájl engedélyezett",
          multipleFileAllow: "Több fájl engedélyezett",
          fileRequiredError: "Legalább egy fájl szükséges",
          linkPlaceholder: "Az URL-nek http/https-sel kell kezdődnie",
          back: "Vissza",
          generateAIField: "Mező generálása AI segítségével",
          shortSummary: "Rövid Összefoglaló",
          provisionPlaceholder: "Adja meg a rendelkezéseket",
          step1: "1. Lépés a 3-ból",
          step2: "2. Lépés a 3-ból",
          step3: "3. Lépés a 3-ból",
          shortSummaryTextTooltip:
            "A szövegmező nem lehet üres a Rövid Összefoglaló mező AI segítségével történő generálásához",
          shortSummaryTooltip:
            "Az Összefoglaló mező nem lehet üres a Rövid Összefoglaló mező AI segítségével történő generálásához",
        },
        feedback: {
          shortSummary: "Rövid AI Összefoglaló",
          class: "Osztályozási Probléma",
          chat: "AI Chat Probléma",
          wrongInfo: "Hibás Információ",
          other: "Egyéb",
          addFeedbackToaster: "A visszajelzés sikeresen elküldve",
          feedbackTitle: "Hagyjon Visszajelzést",
          section: "Szakasz",
          comment: "Megjegyzés",
          files: "Fájlok",
          cancel: "Mégse",
          send: "Küldés",
        },
        example: {
          title: "Példa",
          example1Title: "Weboldal hivatkozás:",
          example2Title: "Keresési/szűrési részletek:",
          example3Title: "Osztályozási beállítások:",
          example4Title: "AI által generált összefoglaló tartalom:",
          example5Title: "Elérhetőségi adatok:",
          example6Title: "Csatolt képernyőképek:",
          example2Text:
            "A „Soud” keresési űrlapban ki kell választani a Legfelsőbb Közigazgatási Bíróságot „Nejvyšší správní soud”. A „Druh dokumentu” részben a Rodzsudek dokumentumtípust kell kiválasztani. A döntések ugyanazon a napon kerülnek kiadásra és közzétételre a weboldalon.",
          example3Text1:
            "Osztályozza a megfigyelt információkat az alábbiak szerint:",
          example3Text2:
            "1. Dokumentumtípus: Határozat, Vélemény, Rendelet, Egyéb",
          example3Text3:
            "2. Egyéni osztályozás: Általános forgalmi adó, Vám, Személyi jövedelemadó.",
          example4Text:
            "Az összefoglalónak tartalmaznia kell az ügy tárgyát, a felek érveit és a bíróság végső döntését.",
          example5Team: "Csapat: Adó Csapat",
          example5Email: "E-mailek: example@deloittece.com",
          example5Text1: "Fő frissítési oldal",
          example5Text2: "Keresési űrlap kiválasztott szűrőkkel",
          example5Text3: "Példa egy szűrt találati oldalra",
        },
        instruction: {
          title: "Útmutató",
          userTitle: "Tisztelt Felhasználó,",
          text0:
            "Ha szeretné hozzáadni a szabályozót a Codet-ben való monitorozáshoz, kérjük, adja meg az alábbi részleteket. Szakértőnk felveszi Önnel a kapcsolatot további pontosítás céljából.",
          text1:
            "Kérjük, adja meg a szabályozó hivatalos weboldalának URL-jét.",
          text2:
            "Ha a weboldal keresőűrlapot vagy szűrőket kínál, kérjük, írja le, hogyan szűkíti általában az Önt érdeklő információkat (pl. dokumentumtípus, kulcsszavak stb. alapján).",
          text3: "Hogyan szeretné osztályozni a monitorozott információkat?",
          text4:
            "Milyen kulcspontokat vagy adatokat kell tartalmaznia az AI által generált összefoglalónak minden egyes dokumentumban vagy frissítésben?",
          text5:
            "Kérjük, adja meg a csapat nevét és az e-mail címeket, hogy kapcsolatba léphessünk Önnel, ha további információra lenne szükség.",
          text6:
            "Annak érdekében, hogy jobban megértsük a szabályozó weboldalának struktúráját, kérjük, csatoljon képernyőképeket a releváns oldalakról vagy keresési űrlapokról a kéréséhez.",
          bestRegards: "Üdvözlettel,",
          codetTeam: "Codet Csapat",
        },
        notification: {
          createNotification: "Értesítés Létrehozása",
          active: "Aktív",
          inactive: "Inaktív",
          subject: "Tárgy",
          team: "Csapat",
          regulators: "Szabályozók",
          classes: "Osztályok",
          schedule: "Ütemezés",
          status: "Állapot",
          all: "Összes",
          days: "A hét napjai",
          time: "Idő",
          timezone: "Időzóna",
          editNotification: "Értesítés Szerkesztése",
          deleteNotification: "Értesítés Törlése",
          deleteNotificationMsg: "Biztosan törölni szeretné ezt az Értesítést?",
          searchNotification: "Keresés: név, e-mail, szerep, csapat",
          frequency: "Értesítések Gyakorisága",
          recipients: "Címzettek",
          create: "Létrehozás",
          step1: "1. Lépés a 2-ból",
          step2: "2. Lépés a 2-ból",
          notificationChangeToaster: "Az értesítés sikeresen frissítve lett",
          deleteNotificationToaster: "Az értesítés sikeresen törölve lett",
          addNotificationToaster: "Az értesítés sikeresen hozzáadva",
          searchAndSelectRecipients: "Keresés és címzettek kiválasztása...",
          searchAndSelectRegulator: "Keresés és szabályozó kiválasztása...",
          subjectPlaceholder: "Adja meg a Tárgyat",
          allClasses: "Összes osztály",
          selectAtLeastOneDay: "Válasszon legalább egy Napot",
          on: "Be",
          off: "Ki",
        },
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
